export function canUseBarcodeCart(userOrRole) {
	const role = typeof userOrRole === "string" ? userOrRole : userOrRole?.yetki;
	return ["admin", "kullanici"].includes(role);
}
